/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://qykdgyzmdjgltjdrauewlfgo5e.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-1:bd01064a-3100-408c-8dd8-0e2d50873e15",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_MtFsnLKLW",
    "aws_user_pools_web_client_id": "70riv953mdtc0f8qrndpm1e40u",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "recordimages165702-dev",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
